<template>
	<!-- 选择机构模态框 -->
	<el-dialog custom-class="selectOrgModal" title="" :visible.sync="modalData.status" fullscreen :show-close="false">
		<div slot="title" class="select-org-modal-header-wrap">
			<div class="select-org-modal-header">
				<img width="28px" src="../assets/images/avatar@2x.png" alt="">
				<p style="margin:0 20px 0 10px;">{{ modalData.phone }}</p>
				<p style="cursor:pointer;" @click="modalData.status = false">退出</p>
			</div>
		</div>
		<div class="select-org-list-wrap">
			<div class="org-list-item-wrap" v-for="(v, i) in modalData.orgList" :key="i">
				<div class="org-logo"
					:style="{ backgroundImage: `url(${v.logo || require('../assets/images/default_org_logo@2x.png')})` }">
				</div>
				<div class="org-list-item-text">
					<div class="org-list-item-name" :class="{ 'not-completed': v.completed == 0 }">
						{{ v.completed == 1 ? v.name : '待完善' }}
					</div>
					<div class="org-list-item-time">有效期：{{ (v.evictTime && v.evictTime.substring(0, 10)) || '--' }}
						<span class="error-text" v-if="v.isExpired == 1">（已过期）</span>
						<span class="error-text" v-if="v.accountStatus == 0">（账号已被禁用）</span>
					</div>
					<div class="org-list-item-btn" :class="{ disabled: v.accountStatus == 0 }" @click="goToAdmin(v)">进入管理
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { Button, Dialog, Message, Loading, } from 'element-ui';
import api from '../api/index';

export default {
	name: 'selectOrgModal',
	components: {
		'el-button': Button,
		'el-dialog': Dialog,
	},
	data() {
		return {
			modalData: {
				status: false,//模态框显示状态
				phone: '',//电话
				validCode: '',//验证码
				orgList: [],//机构列表
				locationUrl: '',//跳转地址
			},
		}
	},
	computed: {
	},
	created() {

	},
	mounted() {
	},
	methods: {
		// 登录
		phoneLogin(data, callback) {
			api.phoneLogin(data, res => {
				console.log('-----phoneLogin-----', res)
				if (res) {
					if ((res.code === 'REQ007') || (res && res.code === 'REQ002')) {
						if (callback) {
							callback('')
						}
						Message.error(res.msg)
					} else if (res.menuNos && res.menuNos !== '') { // 是否有权限登录选中的系统
						const url = `${this.modalData.locationUrl}?token=${res.token}`
						window.location.href = encodeURI(url); // 调试，还要打开的
					} else if (!res.menuNos) {
						if (callback) {
							callback('dialogVisible')//提示没权限弹窗
						}
					}
				} else {
					if (callback) {
						callback('')
					}
				}
			})
		},
		// 进入管理
		goToAdmin(v) {
			if (v.isExpired == 1) {//已过期
				Message.error({
					duration: 5000,
					message: '已超出合作周期，登录失败，请联系客服人员续约'
				});
			} else if (v.accountStatus == 0) {//（账号已被禁用）
				return
			} else if (v.completed == 0) {//未完善信息
				this.modalData.status = false
				this.$emit('showCompleteOrgModal', {
					status: true,
					phone: this.modalData.phone,
					locationUrl: this.modalData.locationUrl,
				})
			} else {
				this.phoneLogin({
					phone: this.modalData.phone,
					validCode: this.modalData.validCode,
					rentId: v.rentId,
				})
			}
		}
	},
};
</script>

<style lang="less" scoped>
/deep/.selectOrgModal {
	background: #F5F5F5;

	.el-dialog__header {
		background: #fff;
		padding: 0 20px;
		border-bottom: 1px solid #E9E9E9;
	}

	.select-org-modal-header-wrap {
		display: flex;
		flex-direction: row-reverse;
		height: 60px;

		.select-org-modal-header {
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #4677F8;
			line-height: 22px;
		}
	}

	.select-org-list-wrap {
		display: flex;
		flex-wrap: wrap;

		.org-list-item-wrap {
			box-sizing: border-box;
			width: 450px;
			height: 136px;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 20px;
			display: flex;
			margin-top: 20px;
			margin-right: 20px;

			.org-logo {
				border-radius: 6px;
				border: 1px solid #e8e8e8;
				width: 96px;
				height: 96px;
				background-size: cover;
				flex-shrink: 0;
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center center;
			}

			.org-list-item-text {
				flex-grow: 1;
				margin-left: 12px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.org-list-item-name {
					font-size: 15px;
					font-weight: bold;
					color: #343537;
					line-height: 22px;

					&.not-completed {
						color: #FF7C34;
					}
				}

				.org-list-item-time {
					font-size: 14px;
					color: #515A6E;
					line-height: 22px;

					.error-text {
						color: #FF0000;
					}
				}

				.org-list-item-btn {
					background: #4677F8;
					border-radius: 4px;
					height: 32px;
					cursor: pointer;
					display: flex;
					color: #fff;
					justify-content: center;
					align-items: center;

					&.disabled {
						background: #C8C8C8;
						cursor: no-drop;
					}
				}

			}
		}
	}
}
</style>
